export default __webpack_public_path__ + "static/media/Smart Heart Rabbit Food Apple.9f7df31e.png";